import { useCallback, useState } from 'react';

/**
 * Collapsed state of the category groups of an order table: which categories are folded, the
 * toggle the category rows call, and a reset for when the displayed catalog changes altogether.
 * Shared by every order view displaying the grouped product tables.
 *
 * @returns {{ collapsedCategories: Array<string>, toggleCategory: Function, resetCollapsedCategories: Function }}
 */
export const useCollapsedCategories = () => {
  const [collapsedCategories, setCollapsedCategories] = useState([]);

  const toggleCategory = useCallback((category) => {
    setCollapsedCategories((currentCategories) =>
      currentCategories.includes(category)
        ? currentCategories.filter((currentCategory) => currentCategory !== category)
        : [...currentCategories, category],
    );
  }, []);

  const resetCollapsedCategories = useCallback(() => {
    setCollapsedCategories([]);
  }, []);

  return { collapsedCategories, toggleCategory, resetCollapsedCategories };
};
